import React from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const steps = [
  'Click and drag on the PDF',
  'Release to place the field',
  'Select it to edit properties',
];

export default function HowToDrawCard() {
  return (
    <div className="rounded-xl border border-secondary/15 bg-secondary/10 px-4 py-4 shadow-sm">
      <div className="text-xl font-semibold leading-6 text-primary">
        Add a field
      </div>
      <p className="mt-1 text-sm leading-5 text-gray-700">
        Draw fields directly onto the PDF.
      </p>

      <div className="mt-4 rounded-xl bg-white/70 px-5 py-4">
        <div className="relative h-11 rounded-lg bg-secondary/10">
          <div className="absolute left-1/2 top-1/2 h-7 w-24 -translate-x-1/2 -translate-y-1/2 rounded border border-dashed border-secondary bg-secondary/20">
            <AddRoundedIcon className="!absolute -bottom-3 -right-3 !h-5 !w-5 text-secondary" />
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-3">
        {steps.map((step, index) => (
          <div key={step} className="flex items-center gap-3 text-sm text-gray-700">
            <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary text-xs font-semibold text-white">
              {index + 1}
            </div>
            <span>{step}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
